export default __webpack_public_path__ + "static/media/logo_myarhery.eccc9424.svg";